import { environment } from '@root/shared'

import * as Deeplink from './deeplink'
import * as DeeplinkURL from './deeplink-url'

const APPLINK_SCHEME = environment.applinkScheme || 'delugecash'

export function getURLFor<T extends DeeplinkURL.KnownPages>(
  page: T,
  ...payload: Parameters<DeeplinkURL.DeeplinkBuilder[T]>
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const pathname = DeeplinkURL.DeeplinkBuilder[page](...(payload as [any]))
  return new URL(APPLINK_SCHEME + '://goto' + pathname)
}

export function fromDeeplink(deeplink: Deeplink.Deeplink) {
  return new URL(
    APPLINK_SCHEME +
      '://goto' +
      Deeplink.match(deeplink, DeeplinkURL.DeeplinkBuilder),
  )
}

export function trigger(url: string | URL | Deeplink.Deeplink) {
  let a
  try {
    a = document.createElement('a')
    if (typeof url === 'string') {
      a.href = url
    } else if (url instanceof URL) {
      a.href = url.toString()
    } else {
      a.href = fromDeeplink(url).toString()
    }
    document.body.appendChild(a)
    a.click()
  } finally {
    if (a) {
      document.body.removeChild(a)
    }
  }
}
